import React from 'react';
import './PartyPopper.less';

const PartyPopper = () => <span className="PartyPopper" />;

export default PartyPopper;
